export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_12.85833d93.jpg";